import { SET_EXCLUDE_PERSONAL_DETAILS } from "redux/types";
import initialState from "redux/initialState";

export default function excludePersonalDetailsReducer(
  state = initialState.excludePersonalDetails,
  action
) {
  switch (action.type) {
    case SET_EXCLUDE_PERSONAL_DETAILS:
      return action.payload;
    default:
      return state;
  }
}
